import HhgImage from './images/moving-truck.jpg';
import TempLivingImage from './images/temporary-living.jpg';
import FinalMoveImage from './images/airplane-travel.jpg';
import HomeFindingImage from './images/home-finding.jpeg';
import HomePurchasingImage from './images/home-purchasing.jpg';
import HomeSaleImage from './images/home-sale.jpg';
import RentalImage from './images/rental-image.jpg';
import SpousalImage from './images/spousal-assistance.jpg';
import GeneralRelocationImage from './images/general-relocation.jpg';
import AdditionalBenefitsImage from './images/misc-benefit.png';

export const getBenefits = (perDiemCost, perDiemMealCost, avgHomesalePrice, avgHomesalePriceOrigin, flightOrMileageCost, homefindingDays, autoShipmentCost, distance) => [
    {
        name: 'Household Goods',
        secondaryText: 'Shipment of your household goods, vehicles, and pets',
        generalBenefitHelp: 'Select a benefit option below to learn more about it',
        imageUrl: HhgImage,
        benefitNumber: 0,
        isSelected: false,
        topLevelInputOne: {
            name: 'Property Type',
            id: 'propertyType',
            options: [
                // { id: 1, label: 'Studio Apt.' },
                { id: 2, label: 'Apartment' },
                // { id: 3, label: 'Condo/ Townhouse' },
                { id: 4, label: 'House' }
            ],
        },
        topLevelInputTwo: {
            name: 'Number of Bedrooms',
            id: 'numBedrooms',
            options: [
                { id: 1, label: '1 Bedroom' },
                { id: 2, label: '2 Bedrooms' },
                { id: 3, label: '3 Bedrooms' },
                { id: 4, label: '4 Bedrooms' },
                { id: 5, label: '5 Bedrooms' }
            ],
        },
        options: [
            {
                description: 'Full Pack, Load, Transport',
                cost: 0,
                optionNumber: 1,
                helpIntentId: 'pack_load_hint_v1'
            },
            {
                description: 'Auto Shipment',
                cost: autoShipmentCost,
                optionNumber: 2,
                helpIntentId: 'auto_shipment_hint_v1',
                defaultSelectionId: 1,
                selections: [{
                  selectionId: 1,
                  text: '1 Vehicle',
                  cost: autoShipmentCost
                }, {
                  selectionId: 2,
                  text: '2 Vehicles',
                  cost: autoShipmentCost * 2
                }, {
                  selectionId: 3,
                  text: '3 Vehicles',
                  cost: autoShipmentCost * 3
                }]
            },
            // {
            //     description: 'Partial unpack.',
            //     cost: 100,
            //     optionNumber: 3
            // },
            // {
            //     description: 'Normal appliance servicing.',
            //     cost: 100,
            //     optionNumber: 4
            // },
            // {
            //     description: 'Crating.',
            //     cost: 100,
            //     optionNumber: 5
            // },
            {
                description: 'Storage',
                cost: 0,
                optionNumber: 6,
                helpIntentId: 'storage_hint_v1',
                defaultSelectionId: 1,
                selections: [{
                  selectionId: 1,
                  text: '30 days',
                  cost: 30
                }, {
                  selectionId: 2,
                  text: '60 days',
                  cost: 60
                }]
            },
            // {
            //     description: 'Insurance.',
            //     cost: 100,
            //     optionNumber: 7
            // },
            // {
            //     description: 'Discard and donate.',
            //     cost: 0,
            //     optionNumber: 8
            // },
        ]
    },
    {
        name: 'Rental',
        secondaryText: 'Costs associated with a rental relocation',
        generalBenefitHelp: 'Select a benefit option below to learn more about it',
        imageUrl: RentalImage,
        benefitNumber: 1,
        isSelected: false,
        isRenterOnly: true,
        options: [
            {
                description: 'Rental Tour',
                cost: 795,
                optionNumber: 9,
                helpIntentId: 'rental_tour_hint_v1',
                defaultSelectionId: 1,
                selections: [{
                  selectionId: 1,
                  text: 'Half-Day Tour',
                  cost: 795
                }, {
                  selectionId: 2,
                  text: 'Full-Day Tour',
                  cost: 995
                }]
            },
            {
                description: 'Lease Cancellation',
                cost: 2500,
                optionNumber: 10,
                helpIntentId: 'lease_cancellation_hint_v1'
            },
        ]
    },
    {
        name: 'Temporary Living',
        secondaryText: 'Temporary housing in your new location',
        generalBenefitHelp: 'Select a benefit option below to learn more about it',
        imageUrl: TempLivingImage,
        benefitNumber: 2,
        isSelected: false,
        topLevelInputThree: {
            name: 'Number of Bedrooms',
            id: 'numBedroomsTempLiving',
            options: [
                { id: 1, label: '1 Bedroom' },
                { id: 2, label: '2 Bedrooms' },
                { id: 3, label: '3 Bedrooms' },
            ],
        },
        options: [
            {
                description: 'Temporary Lodging',
                cost: 6000,
                optionNumber: 11,
                helpIntentId: 'temp_living_days_hint_v1',
                defaultSelectionId: 1,
                selections: [{
                  selectionId: 1,
                  text: 'Up to 30 days',
                  cost: 3000
                }, {
                  selectionId: 2,
                  text: 'Up to 60 days',
                  cost: 6000
                }, {
                  selectionId: 3,
                  text: 'Up to 90 days',
                  cost: 9000
                }]
            },
            {
                description: distance > 350 ? 'Return Trip (Airfare)' : 'Return Trip (Mileage)',
                cost: distance > 350 ? flightOrMileageCost : (flightOrMileageCost * 2),
                optionNumber: 12,
                helpIntentId: 'return_trip_hint_v1',
            },
            {
                description: 'Rental Car',
                cost: 98.89, // Average daily rental car cost
                helpIntentId: 'long_term_car_rental_hint_v1',
                freeNumberField: true,
                freeNumberFieldLabel: 'Enter # of Days',
                freeNumberMultiplier: 'Days',
                freeNumberFieldDefault: 3,
                optionNumber: 13
            },
        ]
    },
    {
        name: 'Home Finding',
        secondaryText: 'Support for new home finding trips',
        generalBenefitHelp: 'Select a benefit option below to learn more about it',
        imageUrl: HomeFindingImage,
        benefitNumber: 3,
        isSelected: false,
        topLevelInputFour: {
            name: 'Accompanying Family',
            id: 'accompanyingFamily',
            options: [
                { id: 1, label: 'Transferee Only' },
                { id: 2, label: 'Transferee and Spouse' },
                { id: 3, label: 'Transferee and Family' },
            ],
        },
        options: [
            {
                description: distance > 350 ? 'Airfare' : 'Mileage',
                cost: distance > 350 ? flightOrMileageCost : (flightOrMileageCost * 2),
                helpIntentId: 'airfare_hint_v1',
                optionNumber: 14
            },
            {
                description: 'Lodging',
                cost: (perDiemCost * 1.2),
                optionNumber: 15,
                helpIntentId: 'per_diem_hint_v1', // 'lodging_hint_homefinding_v1'
                defaultSelectionId: 10,
                selections: [{
                    selectionId: 8,
                    text: '1 Day',
                    cost: (perDiemCost * 1.2)
                }, {
                    selectionId: 9,
                    text: '2 Days',
                    cost: (perDiemCost * 1.2) * 2
                }, {
                    selectionId: 10,
                    text: '3 Days',
                    cost: (perDiemCost * 1.2) * 3
                }, {
                    selectionId: 11,
                    text: '4 Days',
                    cost: (perDiemCost * 1.2) * 4
                }, {
                    selectionId: 12,
                    text: '5 Days',
                    cost: (perDiemCost * 1.2) * 5
                }, {
                    selectionId: 13,
                    text: '6 Days',
                    cost: (perDiemCost * 1.2) * 6
                }, {
                    selectionId: 14,
                    text: '7 Days',
                    cost: (perDiemCost * 1.2) * 7
                }]
            },
            {
                description: 'Meals',
                cost: perDiemMealCost,
                optionNumber: 31,
                helpIntentId: 'meals_hint_homefinding_v1',
                defaultSelectionId: 3,
                selections: [{
                    selectionId: 1,
                    text: '1 Day',
                    cost: perDiemMealCost
                }, {
                    selectionId: 2,
                    text: '2 Days',
                    cost: perDiemMealCost * 2
                }, {
                    selectionId: 3,
                    text: '3 Days',
                    cost: perDiemMealCost * 3
                }, {
                    selectionId: 4,
                    text: '4 Days',
                    cost: perDiemMealCost * 4
                }, {
                    selectionId: 5,
                    text: '5 Days',
                    cost: perDiemMealCost * 5
                }, {
                    selectionId: 6,
                    text: '6 Days',
                    cost: perDiemMealCost * 6
                }, {
                    selectionId: 7,
                    text: '7 Days',
                    cost: perDiemMealCost * 7
                }]
            },
            {
                description: 'Rental Car',
                cost: 98.89 * homefindingDays,
                helpIntentId: 'car_rental_hint_v1',
                optionNumber: 17
            },
            {
                description: 'Airport transportation',
                cost: 61.71,
                helpIntentId: 'airport_parking_hint_v1',
                optionNumber: 18
            },
        ]
    },
    {
        name: 'Home Purchasing',
        secondaryText: 'Support for new home purchasing',
        generalBenefitHelp: 'Select a benefit option below to learn more about it',
        imageUrl: HomePurchasingImage,
        benefitNumber: 4,
        isSelected: false,
        options: [
            {
                description: 'Home Purchase Closing Costs',
                cost: avgHomesalePrice * .02,
                optionNumber: 19,
                helpIntentId: 'direct_bill_hint_v1'
            },
            // {
            //     description: 'Referrals to preferred agents.',
            //     cost: 0,
            //     optionNumber: 20,
            //     helpIntentId: 'referrals_hint_v1'
            // },
        ]
    },
    {
        name: 'Home Sale',
        secondaryText: 'Assistance with home sale',
        generalBenefitHelp: 'The home sale benefit covers normal and customary seller\'s closing costs. Select a benefit option below to learn more, and choose which benefit you\'d like to include in the estimate.',
        imageUrl: HomeSaleImage,
        benefitNumber: 5,
        isSelected: false,
        isOwnerOnly: true,
        options: [
            {
                description: 'Tax-protected homesale program',
                cost: avgHomesalePriceOrigin * .08,
                optionNumber: 21,
                helpIntentId: 'direct_reimbursment_hint_v1'
            },
        ]
    },
    {
        name: 'Spouse / Partner Assistance',
        secondaryText: 'Assistance for the spouse / partner in the new location',
        generalBenefitHelp: 'Select a benefit option below to learn more about it',
        imageUrl: SpousalImage,
        benefitNumber: 6,
        isSelected: false,
        options: [
            {
                description: 'Spouse / Partner Assistance',
                cost: 1250,
                optionNumber: 22,
                helpIntentId: 'spouse_assistance_hint_v1'
            },
        ]
    },
    {
        name: 'Relocation Allowance',
        secondaryText: 'Custom allowance for general relocation costs',
        generalBenefitHelp: 'The relocation allowance provides transferees with a fixed amount to cover incidental expenses related to relocation that are not covered by other benefits.',
        imageUrl: GeneralRelocationImage,
        benefitNumber: 8,
        isSelected: false,
        customTotal: true,
        options: [
            {
                description: 'Allowance for miscellaneous benefits',
                customTotal: true,
                optionNumber: 27
                // helpIntentId: 'relocation_allowance_hint_v1'
            },
        ]
    },
    {
        name: 'Final Move',
        secondaryText: 'Costs associated with the final trip',
        generalBenefitHelp: 'These are common final move costs to travel to the destination. Select a benefit option below to learn more, and choose which benefits you\'d like to include in the estimate.',
        imageUrl: FinalMoveImage,
        benefitNumber: 7,
        isSelected: false,
        options: [
            {
                description: distance > 350 ? 'Travel' : 'Travel', // over 350 miles is airfare, under is mileage
                cost: distance > 350 ? (parseFloat(flightOrMileageCost) / 2) : flightOrMileageCost,
                helpIntentId: 'airfare_oneway_hint_v1',
                optionNumber: 23
            },
            {
                description: 'Lodging',
                cost: (perDiemCost * 1.2),
                optionNumber: 24,
                helpIntentId: 'per_diem_hint_v1',
                defaultSelectionId: 6,
                selections: [{
                    selectionId: 4,
                    text: '1 Day',
                    cost: (perDiemCost * 1.2)
                }, {
                    selectionId: 5,
                    text: '2 Days',
                    cost: (perDiemCost * 1.2) * 2
                }, {
                    selectionId: 6,
                    text: '3 Days',
                    cost: (perDiemCost * 1.2) * 3
                }, {
                    selectionId: 7,
                    text: '4 Days',
                    cost: (perDiemCost * 1.2) * 4
                }]
            },
            {
                description: 'Meals',
                cost: perDiemMealCost,
                optionNumber: 32,
                helpIntentId: 'meals_hint_homefinding_v1', // 'per_diem_hint_v1'
                defaultSelectionId: 3,
                selections: [{
                    selectionId: 1,
                    text: '1 Day',
                    cost: perDiemMealCost
                }, {
                    selectionId: 2,
                    text: '2 Days',
                    cost: perDiemMealCost * 2
                }, {
                    selectionId: 3,
                    text: '3 Days',
                    cost: perDiemMealCost * 3
                }, {
                    selectionId: 4,
                    text: '4 Days',
                    cost: perDiemMealCost * 4
                }]
            },
            {
                description: 'Transportation to/from airport',
                cost: 33.68,
                helpIntentId: 'airport_transportation_hint_v1',
                optionNumber: 26
            },
        ]
    },
    {
        name: 'Additional Benefits',
        secondaryText: 'Customizable benefits based on your employee needs',
        generalBenefitHelp: 'Enter any additional benefits to be included in the estimate.',
        customBenefit: true,
        imageUrl: AdditionalBenefitsImage,
        benefitNumber: 9,
        options: [
            {
                description: 'Custom Option One',
                customOption: true,
                optionNumber: 28
            },
            {
                description: 'Custom Option Two',
                customOption: true,
                optionNumber: 29
            },
            {
                description: 'Custom Option Three',
                customOption: true,
                optionNumber: 30
            },
        ]
    },
]